import React from 'react';
import {Route} from 'react-router-dom';


/**
 * @step 1900: react router make routes from HomeRoutes
 */
const RouteGenerator = (props) => {
    return props.map((route, index) => {
        return (
            <Route key={route.path} path={route.path} element={route.element}>
                {route.children ? (
                    route.children.map((child, index) => {
                        return (
                            <Route
                                key={child.path}
                                path={child.path}
                                element={child.element}
                            />
                        );
                    })
                ) : (
                    <></>
                )}
            </Route>
        );
    });
};

export default RouteGenerator;
